import { MoviesModel } from '@modules/entertainment/models/movies.model.ts';
import { TableSelectionColumnParams } from '@models/table.model.ts';
import { Tooltip } from '@mui/material';
import AppImage from '@components/app-image/app-image.tsx';
import RowActions from '@components/row-actions/row-actions.tsx';
import { getSelectColumn } from '@utils/table-selection.utils.tsx';

export const moviesColumns = (
  handleEdit: (row: any) => void,
  handleDelete: (row: any) => void,
  selection: TableSelectionColumnParams<MoviesModel>,
  language: string
) => [
  getSelectColumn<MoviesModel>(selection),
  {
    id: 'title',
    label: 'column_label_title',
    field: 'title',
    render: (value: any) => (
      <Tooltip title={value?.[language]} followCursor>
        <span>{value?.[language] || 'N/A'}</span>
      </Tooltip>
    ),
    showSort: false,
    showSearch: true,
    showFilter: false,
    isTranslated: true
  },
  {
    id: 'poster',
    label: 'column_label_poster',
    field: 'poster',
    render: (value: any) => (
      <div
        className={`h-13 w-13 rounded-md border border-(--gray-7) overflow-hidden cursor-pointer`}
      >
        <AppImage imgClassName="!h-full" filePath={value ?? undefined} />
      </div>
    ),
    showSort: false,
    showSearch: false,
    showFilter: false,
    isTranslated: false
  },
  {
    id: 'backdrop',
    label: 'column_label_backdrop',
    field: 'backdrop',
    render: (value: any) => (
      <div
        className={`h-13 w-13 rounded-md border border-(--gray-7) overflow-hidden cursor-pointer`}
      >
        <AppImage imgClassName="!h-full" filePath={value ?? undefined} />
      </div>
    ),
    showSort: false,
    showSearch: false,
    showFilter: false,
    isTranslated: false
  },
  {
    id: 'description',
    label: 'column_label_description',
    field: 'description',
    render: (value: any) => (
      <Tooltip title={value?.[language]} followCursor>
        <span>{value?.[language] || 'N/A'}</span>
      </Tooltip>
    ),
    showSort: false,
    showSearch: true,
    showFilter: false,
    isTranslated: true
  },
  {
    id: 'genres',
    label: 'column_label_genres',
    field: 'genres',
    render: (value: any) => {
      const names = Array.isArray(value)
        ? value
            .map((genre: any) => genre?.name?.[language])
            .filter(Boolean)
            .join(', ')
        : 'N/A';

      return (
        <Tooltip title={names || 'N/A'} followCursor>
          <span>{names || 'N/A'}</span>
        </Tooltip>
      );
    },
    owSort: false,
    showSearch: false,
    showFilter: false,
    isTranslated: false
  },
  {
    id: 'url',
    label: 'column_label_url',
    field: 'url',
    render: (value: any) => (
      <Tooltip title={value} followCursor>
        <span
          style={{
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '250px',
            lineHeight: '1.4em'
          }}
        >
          {value || 'N/A'}
        </span>
      </Tooltip>
    ),
    showSort: false,
    showSearch: false,
    showFilter: false,
    isTranslated: false
  },
  {
    id: 'date',
    label: 'column_label_date',
    field: 'date',
    render: (value: any) => (
      <Tooltip
        title={value ? new Date(value).toLocaleDateString() : 'N/A'}
        followCursor
      >
        <span>{value ? new Date(value).toLocaleDateString() : 'N/A'}</span>
      </Tooltip>
    ),
    showSort: true,
    showSearch: false,
    showFilter: false,
    isTranslated: false
  },
  {
    id: 'Action',
    label: 'column_label_actions',
    field: 'actions',
    render: (value: any, row: any) => (
      <RowActions<any>
        row={row}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
      />
    ),
    showSort: false,
    showSearch: false,
    showFilter: false
  }
];
